import { useState } from "react";
import { TextInput } from "../../ui/TextInput.js";
import VisibilityIcon from "../../icon/VisibilityIcon.js";
import VisibilityOffIcon from "../../icon/VisibilityOffIcon.js";


interface PasswordInputProps {
    id: string;
    name?: string;
    value: string;
    setValue: (value: string) => void;
    autoComplete?: string;
    required?: boolean;
}

export function PasswordInput({
    id, name, value, setValue, autoComplete, required,
}: PasswordInputProps) {
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);
    return (
        <div className="relative mt-1 mb-2 w-full">
            <TextInput
                className="m-0 pr-[2.4em] [&::-ms-reveal]:hidden"
                type={showPassword ? "text" : "password"}
                id={id}
                name={name}
                value={value}
                onChange={e => setValue(e.target.value)}
                autoComplete={autoComplete}
                required={required} />

            <button
                className="absolute top-0 right-0 h-full cursor-pointer px-[0.8em] opacity-60 [&_svg]:h-auto [&_svg]:w-[1.8em]"
                type="button"
                role="switch"
                aria-checked={showPassword}
                onClick={togglePassword}>

                {showPassword && <VisibilityOffIcon />}
                {!showPassword && <VisibilityIcon />}

                <span className="sr-only">
                    {showPassword ? "Hide password" : "Show password"}
                </span>
            </button>
        </div>
    );
}
